import React from "react";

function CategoryBars({ categoryScores }) {
  const entries = Object.entries(categoryScores || {});
  if (entries.length === 0) return null;
  return (
    <div className="geo-bars">
      {entries.map(([cat, v]) => {
        const pct = v?.pct ?? 0;
        return (
          <div className="geo-bar" key={cat}>
            <div>{cat}</div>
            <div className="track"><div className="fill" style={{ width: `${pct}%` }} /></div>
            <div className="subtle">{pct.toFixed(0)}%</div>
          </div>
        );
      })}
    </div>
  );
}

export default function GeoSnapshot({ snapshot, mode = "agency" }) {
  if (!snapshot) return <div className="empty">No GEO snapshot yet.</div>;
  return (
    <div>
      <div className="row">
        <div className="score-big">
          {snapshot.score_pct.toFixed(1)}
          <small>%</small>
        </div>
        <div style={{ flex: 1 }}>
          <div className="subtle">
            {snapshot.total_score} / {snapshot.max_possible} points
          </div>
          <div className="subtle">month: {snapshot.month}</div>
          {snapshot.previous_month_score != null && (
            <div className="subtle">prior month: {snapshot.previous_month_score}</div>
          )}
        </div>
      </div>

      <h3 style={{ marginTop: 20 }}>By AI platform</h3>
      <div className="geo-bars">
        {[
          ["ChatGPT", snapshot.chatgpt_score],
          ["Gemini", snapshot.gemini_score],
          ["Perplexity", snapshot.perplexity_score],
          ["Google AIO", snapshot.google_aio_score],
        ].map(([label, v]) => (
          <div className="geo-bar" key={label}>
            <div>{label}</div>
            <div className="track">
              <div
                className="fill"
                style={{ width: `${Math.min(100, (v / Math.max(1, snapshot.max_possible / 4)) * 100)}%` }}
              />
            </div>
            <div className="subtle">{v}</div>
          </div>
        ))}
      </div>

      <h3 style={{ marginTop: 20 }}>By category</h3>
      <CategoryBars categoryScores={snapshot.category_scores} />

      {mode === "agency" && snapshot.top_gaps?.length > 0 && (
        <>
          <h3 style={{ marginTop: 20 }}>Top gaps</h3>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {snapshot.top_gaps.slice(0, 6).map((g, i) => (
              <li key={i} style={{ fontSize: 14, marginBottom: 4 }}>
                <strong>{g.query}</strong>
                <span className="subtle"> — {g.category} (zero on {g.zero_on_platforms})</span>
              </li>
            ))}
          </ul>
        </>
      )}

      {mode === "agency" && snapshot.competitors_summary?.length > 0 && (
        <>
          <h3 style={{ marginTop: 20 }}>Competitors surfacing</h3>
          <ul className="competitors">
            {snapshot.competitors_summary.slice(0, 10).map((c, i) => (
              <li key={i}>{c.name} <span className="subtle">×{c.mentions}</span></li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
